import { render, staticRenderFns } from "./CompleteOrder.vue?vue&type=template&id=ec51a226"
import script from "./CompleteOrder.vue?vue&type=script&lang=js"
export * from "./CompleteOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports